module.exports = __webpack_public_path__ + "assets/img/Managing.b3c710c8.svg";